var Index = function(){

		var isMobile = 992;
		var isLaptop = 1366;
	  var wWidth = $(window).width();

		ScrollAnimation();


	$('.navbar-toggle').on('click', function(){
		var menu = $(this);
		menu.prev('nav').toggleClass('show');


		if($('nav').hasClass('show'))
		{
			$('.menu-fixed').css('background-color', '#fff');
		}else
		{
			// $(window).scrollTop()
		}
	})

	$('.lightbox').on('click', function(e){
		e.preventDefault();

		// if(wWidth > isMobile){

			var modal = $('[data-component="lightbox"]');
			TweenMax.fromTo( $('.modal-bg'), 0.5, {css:{alpha:0,display:'block'}}, {css:{alpha:1}, ease:Power1.easeOut});
			TweenMax.fromTo( modal, 0.5, {css:{alpha:0,display:'block'}}, {css:{alpha:1}, ease:Power1.easeOut});
			modal.addClass('fade');

			$('body').css('overflow','hidden');
		// }

	})

	$('.btn-contact').on('click', function(e){
		e.preventDefault();

		// if(wWidth > isMobile){

		var modal = $('[data-component="form-contact"]');
		TweenMax.fromTo( $('.modal-bg'), 0.5, {css:{alpha:0,display:'block'}}, {css:{alpha:1}, ease:Power1.easeOut});
		TweenMax.fromTo( modal, 0.5, {css:{alpha:0,display:'block'}}, {css:{alpha:1}, ease:Power1.easeOut});
		modal.addClass('fade');

		$('body').css('overflow','hidden');

		//}
	})
	$('[data-component="lightbox"] .close').on('click', function(e){
		e.preventDefault();

		var modal = $('[data-component="lightbox"]');
		modal.removeClass('fade');

		TweenMax.fromTo( modal, 0.5, {css:{alpha:1 ,display:'block'}}, {css:{alpha:1}, ease:Power1.easeOut, onComplete:function(){
			TweenMax.fromTo( $('.modal-bg'), 0.5, {css:{alpha:1 ,display:'none'}}, {css:{alpha:0}, ease:Power1.easeOut});
		}});
		$('body').css('overflow','auto');
	})

	$('[data-component="form-contact"] .close').on('click', function(e){
		e.preventDefault();

		var modal = $('[data-component="form-contact"]');
		modal.removeClass('fade');

		TweenMax.fromTo( modal, 0.5, {css:{alpha:1 ,display:'block'}}, {css:{alpha:1}, ease:Power1.easeOut, onComplete:function(){
			TweenMax.fromTo( $('.modal-bg'), 0.5, {css:{alpha:1 ,display:'none'}}, {css:{alpha:0}, ease:Power1.easeOut});
		}});
		$('body').css('overflow','auto');
	})
	$( "input.form-control" ).on('focus', function() {
	  	$(this).prev('label').addClass('ToTop');
	});

	$( "input.form-control" ).on('focusout', function() {
	  	$(this).prev('label').toggleClass('ToTop');
	  	if($(this).val() != ''){
	  		$(this).prev('label').addClass('ToTop');
	  	}else{
	  		$(this).prev('label').removeClass('ToTop');
	  	}
	});

	$(".where-to-use-item").hover(function() {

		$(this).toggleClass('hover-icon');
		$(this).find('h4').toggleClass('hover-icon');
		$(this).find('img').toggleClass('svg_invert');

		var icon = $(this).find('.icon');
		$(icon).toggleClass('hover-icon');

	}, function() {
	  $(this).toggleClass('hover-icon');
	  $(this).find('h4').toggleClass('hover-icon');
	  $(this).find('img').toggleClass('svg_invert');

	  var icon = $(this).find('.icon');
	  $(icon).toggleClass('hover-icon');
	});

	var handMobile = $(".hand-mobile"),
		title = $('#title'),
		title2 = $('#title-1'),
	    handMobileMore = $(".hand-mobile-more"),
	    handsKeyboard = $(".hands-keyboard"),
	    handsTablet = $(".hands-tablet"),
	    homeIcons = $('.home-icons');

		if($('[data-page="home"]').length > 0) {
			var clock = $('.training-clock');
			var flowChart = $('.flow-chart');
			var attendance = $('.attendance');
			var iconClock = $('.icon-training-clock');
			var iconFlowChart = $('.icon-flow-chart');
			var iconAttendance = $('.icon-attendance');
			var highParagr = $('.highlight-item p');

			$(clock).addClass('fade-in');
			$(flowChart).addClass('fade-in');
			$(attendance).addClass('fade-in');
			$(highParagr).addClass('fade-in');
			$(iconClock).addClass('fade-in');
			$(iconFlowChart).addClass('fade-in');
			$(iconAttendance).addClass('fade-in');
		}

		var tl = new TimelineLite();

	    tl.from(title, 0.5, {scale: 0, autoAlpha: 0})
	    .from(title2, 0.5, {scale: 0, autoAlpha: 0}, "-=0.5")
	    .staggerFrom(homeIcons, 0.5, {scale: 0, rotation: -180, autoAlpha: 0}, 0.2, "stagger")
	    .from(handMobile, 0.5, {left: -300,top: -300, autoAlpha: 0})
	    .from(handsKeyboard, 0.5, {right: -300, top: -300, autoAlpha: 0})
	    .from(handMobileMore, 0.5, {bottom: -300, right: -300, autoAlpha: 0}, "-=0.25")
	    .from(handsTablet, 0.5, {bottom: -300, left: -300, autoAlpha: 0}, "-=0.5");

		var prev = 0;
		var $window = $(window);
		var nav = $('.menu-fixed');

		$window.on('scroll', function(){
		  var scrollTop = $window.scrollTop();
		  nav.toggleClass('menu-hide', scrollTop > prev);
		  prev = scrollTop;

		  if(prev < 100)
		  {
		  	nav.css({
		  		'background-color':'transparent',
		  		'box-shadow':'none'
		  	});
		  }
		  else
		  {
		  	nav.css({
		  		'background-color':'#fff',
		  		'box-shadow':'0 4px 4px -2px rgba( 0, 0, 0, 0.1 )'
		  	});
		  }
		});

		// $('[data-page="home-flow"]').prev('.ShowMenu').css('display','none');
};

function ScrollAnimation(){
    var lampWhiteLeft = $('.lamp-white-left');
    var lampOrange = $('.lamp-orange');
    var lampPurple = $('.lamp-purple-left');
    var lampClaret = $('.lamp-claret');
    var woman = $('.woman');
		var isMobile = 992;
		var isLaptop = 1366;
	    var wWidth;

	if($('[data-page="home"]').length > 0)
	{
		$( document ).scroll(function() {

			wWidth = $(window).width();

			if( wWidth > isMobile && wWidth <= isLaptop){

				var wScrollTop = $(window).scrollTop() + 560;

			}else if(wWidth <= isMobile)
			{
				var wScrollTop = $(window).scrollTop() + 700;
			}else
			{
				var wScrollTop = $(window).scrollTop() + 700;
			}

		   	if(wScrollTop > woman.offset().top){
		    	$(lampOrange).addClass('fade-in');
		    	setTimeout(function(){
		    		$(lampWhiteLeft).addClass('fade-in');
		    	}, 600);
		    	setTimeout(function(){
		    		$(lampPurple).addClass('fade-in');
		    	}, 800);
		    	setTimeout(function(){
		    		$(lampClaret).addClass('fade-in');
		    	}, 1000);

		    }

		});
	}

};

ScrollAnimation();
